// Data Anomaly Watcher API client (admin). Watchers themselves are scheduled
// jobs (kind "anomaly") managed via lib/jobs.js; these are the watcher-specific
// helpers: test one check's metric SQL, and read per-check baseline values.
import { api } from './api.js';

// → { ok:true, value } | { ok:false, error }
export const testAnomalyCheck = (connectionId, database, sql) =>
  api.post('/api/tools/anomaly/test', { connectionId: Number(connectionId), database: database || '', sql });

// → { checkId: lastValue, … }
export const anomalyState = (jobId) =>
  api.get(`/api/tools/anomaly/${jobId}/state`).then((r) => r.state || {});

// Operator metadata for the editor. relative ops compare to the previous run.
export const OPERATORS = [
  { op: '<',       label: 'is less than',        relative: false },
  { op: '<=',      label: 'is ≤',                relative: false },
  { op: '>',       label: 'is greater than',     relative: false },
  { op: '>=',      label: 'is ≥',                relative: false },
  { op: '==',      label: 'equals',              relative: false },
  { op: '!=',      label: 'is not',              relative: false },
  { op: 'drop%',   label: 'dropped ≥ … %',       relative: true },
  { op: 'rise%',   label: 'rose ≥ … %',          relative: true },
  { op: 'change%', label: 'changed ≥ … %',       relative: true },
];
export const isRelativeOp = (op) => OPERATORS.find((o) => o.op === op)?.relative || false;

// Check templates. build(f) returns { sql, operator, threshold } from the
// template fields (table/column/lo/hi); 'custom' has no generator.
const q = (id) => '`' + String(id || '').replace(/`/g, '``') + '`';
export const TEMPLATES = [
  { id: 'rowcount',  label: 'Row count',     needs: ['table'],
    build: (f) => ({ sql: `SELECT COUNT(*) FROM ${q(f.table)}`, operator: 'drop%', threshold: 20 }) },
  { id: 'empty',     label: 'Empty table',   needs: ['table'],
    build: (f) => ({ sql: `SELECT COUNT(*) FROM ${q(f.table)}`, operator: '<', threshold: 1 }) },
  { id: 'nullcount', label: 'NULL count',    needs: ['table', 'column'],
    build: (f) => ({ sql: `SELECT COUNT(*) FROM ${q(f.table)} WHERE ${q(f.column)} IS NULL`, operator: '>', threshold: 0 }) },
  { id: 'staleness', label: 'Staleness (h)', needs: ['table', 'column'],
    build: (f) => ({ sql: `SELECT TIMESTAMPDIFF(HOUR, MAX(${q(f.column)}), NOW()) FROM ${q(f.table)}`, operator: '>', threshold: 24 }) },
  { id: 'duplicate', label: 'Duplicate keys', needs: ['table', 'column'],
    build: (f) => ({ sql: `SELECT COUNT(*) - COUNT(DISTINCT ${q(f.column)}) FROM ${q(f.table)}`, operator: '>', threshold: 0 }) },
  { id: 'range',     label: 'Out of range',  needs: ['table', 'column', 'lo', 'hi'],
    build: (f) => ({ sql: `SELECT COUNT(*) FROM ${q(f.table)} WHERE ${q(f.column)} < ${Number(f.lo) || 0} OR ${q(f.column)} > ${Number(f.hi) || 0}`, operator: '>', threshold: 0 }) },
  { id: 'custom',    label: 'Custom SQL',    needs: [] },
];
